<template>
  <div>
    <b-row>
  <b-col cols="12" sm="2" class="mb-1">
    <b-form-group class="mb-0" label="Per page">
      <b-form-select id="perPageSelect" v-model="perPage" 
        :options="pageOptions.map(option => ({ text: option, value: option }))" 
        size="sm"  />
    </b-form-group>
  </b-col>

  <b-col cols="12" sm="3" class="mb-1">
    <b-form-group label="Filter" class="mb-0">
      <b-input-group size="sm">
        <b-form-input id="filterInput" v-model="searchQuery" @input="onSearch" type="search"
          placeholder="Type to Search" />
        <b-input-group-append>
          <b-button :disabled="!searchQuery" @click="searchQuery = ''">
            Clear
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </b-col>
</b-row>

    <b-row>
      <b-col cols="12"  class="d-flex justify-content-end my-1">
      <b-button variant="primary" @click="$bvModal.show('add-segment-modal')">
        Add Segment
      </b-button>
    </b-col>
    <b-col cols="12">
      <b-table striped hover responsive :items="filteredLeads" :fields="fields" :per-page="perPage"
        :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" v-if="!loading">
        <template #cell(view_customer)="data">
          <b-button variant="primary" @click="ViewCustomersBySegment(data.item)">
              View Customer
            </b-button>
        </template>
        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="prepareEditLead(data.item)">
              <feather-icon icon="EditIcon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="deleteFeedback(data.item.segmentId)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <b-col cols="12" v-if="!loading">
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center" size="sm"
          class="my-0"></b-pagination>
      </b-col>
    </b-col>



    <!-- Modal for add -->
    <b-modal id="add-segment-modal" title="Add Segment" @ok.prevent="onSubmit" @hidden="resetForm">
      <b-row>
        <b-col cols="12">
          <b-card title="Add Segment" class="mb-3">
            <validation-observer ref="AddForm">
              <b-form @submit.prevent="onSubmit">
                <!-- Name Field -->
                <b-form-group label="Segment Name:" label-for="lead-name">
                  <validation-provider #default="{ errors }" name="Segment Name" vid="Segment Name" rules="required">
                    <b-form-input id="lead-name" type="text" v-model="form.name" placeholder="Enter Segment name"
                      required></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- <b-form-group label="Criteria:" label-for="lead-name">
                  <validation-provider #default="{ errors }" name="Criteria" vid="Criteria" rules="required">
                    <b-form-input id="lead-name" type="text" v-model="form.criteria" placeholder="Enter Criteria"
                      required></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group> -->

              </b-form>
            </validation-observer>
          </b-card>
        </b-col>

      </b-row>
      <template #modal-footer="{ ok }">
        <b-button type="submit" variant="primary" :disabled="submitting" @click="onSubmit">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Adding...' : 'Add' }}
        </b-button>
      </template>
    </b-modal>



    <b-modal id="edit-segment-modal" title="Edit Segment" @ok.prevent="onEditSubmit">
      <b-row>
        <b-col cols="12">
          <b-card title="Edit Segment" class="mb-3">
            <validation-observer ref="EditForm">
              <b-form @submit.prevent="onEditSubmit">
                <!-- Fields similar to the add modal but with existing values -->
                <b-form-group label="Segment Name:" label-for="edit-lead-first-name">
                  <validation-provider #default="{ errors }" name="Segment Name" vid="Segment Name" rules="required">
                    <b-form-input id="edit-lead-first-name" type="text" v-model="editForm.name"
                      placeholder="Enter Segment name" required></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- <b-form-group label="Critenia:" label-for="edit-lead-last-name">
                  <validation-provider #default="{ errors }" name="Critenia" vid="Critenia" rules="required">
                    <b-form-input id="edit-lead-last-name" type="text" v-model="editForm.criteria"
                      placeholder="Enter lead last name" required></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group> -->


              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <b-button type="submit" variant="primary" :disabled="submitting" @click="onEditSubmit">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Updating...' : 'Update' }}
        </b-button>
      </template>
    </b-modal>

  </b-row>
</div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormSelect,
  BTab,
  BTabs,
  BContainer,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BFormDatepicker,
  BInputGroupAppend,
  VBModal,
  BButton,
  BSpinner,
  BModal,
  BDropdown,
  BFormTextarea,
  BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@/@core/utils/validations/validations";
export default {
  components: {
    BTable,
    BAvatar,
    BForm,
    BTab,
    BTabs,
    BModal,
    BBadge,
    BRow,
    BContainer,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    VBModal,
    BFormInput,
    BFormDatepicker,
    BFormTextarea,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    required,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      formState: {},
      selectedCampaignId: '',
      id: this.$route.params.id,
      selectedStatus: null,
      changingcomplaint: null,
      showModal: false,
      currentTab: 'All',
      searchQuery: '',
      pageOptions: [3, 5, 10],
      perPage: 5,
      fields: [
        { key: "name", label: "Segment Name", sortable: true },
        // { key: "criteria", label: "Criteria" },
        { key: "view_customer", label: "View Customer" },
        { key: "actions" },
      ],
      currentPage: 1,
      perPage: 5,
      campaigns: [],
      form: {
        name: '',
        criteria: null,
        isActive: true,
      },

      editForm: {
        name: '',
        criteria: null,
        isActive: true,

      },
      sources: ['Facebook', 'Instagram', 'LinkedIn', 'Others'],
      sortBy: '',
      sortDesc: false,
      optionsCustomer: [],
      submitting: false,
    };
  },
  computed: {
    rows() {
      return this.filteredLeads.length;
    },
    campaignOptions() {
      return [{ value: '', text: 'All Campaigns' }].concat(
        this.marketingcampaign.map(campaign => ({
          value: campaign.id,
          text: campaign.name
        }))
      );
    },
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),

    filteredLeads() {
      return this.segments.filter((lead) => {
        return (!this.searchQuery || Object.keys(lead).some(key =>
          String(lead[key]).toLowerCase().includes(this.searchQuery.toLowerCase())))
      });
    },

    currentStatus() {
      const statusMapping = {
        0: 'All',
        1: 'New',
        2: 'InProgress',
        3: 'ClosedWon',
        4: 'ClosedLost'
      };

      return statusMapping[this.currentTab];
    },
  },

  methods: {
    ...mapActions("marketingleadsModule", ["getMarketingLeadAction", "postMarketingLeadAction", "putMarketingLeadAction"]),
    ...mapActions("campaignModule", ["getMarketingCampaignAction"]),
    ...mapActions("segmentModule", ["getSegmentsAction", "removeSegmentAction", "addSegmentAction", "updateSegmentAction"]),


    resetForm() {
      this.form = {
        campaignId: "",
        firstName: '',
        lastName: '',
        email: '',
        source: '',
        status: 'New',
        isActive: true,
      };
    },
    // Helper methods
    success(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg || " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (Object.prototype.hasOwnProperty.call(errors, prop) && prop !== "request") {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    ViewCustomersBySegment(segment) {
      this.$router.push({
        name: "email-segment-customers",
        params: { id: segment.segmentId },
      });
    },

    beautifyStatus(status) {
      return status
        .split(/(?=[A-Z])/)
        .join(' ')
        .trim();
    },

    prepareEditLead(lead) {
      this.editForm = { ...lead };
      this.$bvModal.show('edit-segment-modal');
    },


    async deleteFeedback(id) {
      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this segment!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false
      });

      if (result.isConfirmed) {
        this.$swal({
          title: 'Deleting...',
          text: 'Please wait while the segment is being deleted...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        try {
          await this.removeSegmentAction(id)
          this.success('Segment deleted successfully!');
        } catch (error) {
          if (error.response.status === 409)
          {
              this.$swal({
              title: 'Deletion Failed!',
              text: 'Segment related to customer(s)',
              icon: 'error',
              confirmButtonText: 'OK',
              customClass: {
                confirmButton: "btn btn-primary"
              },
              buttonsStyling: false
            });
          }
          else
            {
              this.error("There was a problem deleting the segment. Please try again.");
            }
        } finally {
          await this.getSegmentsAction()
        }
      }
    },



    promptChangeStatus(complaint) {
      this.changingcomplaint = complaint;
      this.selectedStatus = complaint.status;
      this.$bvModal.show("change-status-modal");
    },

    async onEditSubmit() {
      this.submitting = true;
      const isValid = await this.$refs.EditForm.validate();
      if (isValid) {

        try {
          await this.updateSegmentAction(this.editForm);
          this.success('Segment updated successfully!');

        } catch (error) {
          this.error(error.response.data);
        } finally {
          this.submitting = false;
          this.$bvModal.hide('edit-segment-modal');
          this.getSegmentsAction();
        }
      } else {
        this.submitting = false;
        // this.getSegmentsAction();
      }
    },



    async onSubmit() {
      this.submitting = true;
      const isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        try {
          const payload = {
            ...this.form,
          };
          await this.addSegmentAction(payload);
          this.success('Segment added successfully!');
        } catch (error) {
          this.error(error.response.data);
        } finally {
          this.submitting = false;
          this.$bvModal.hide("add-segment-modal");
          this.resetForm();
          await this.getSegmentsAction()
        }
      } else {
        this.submitting = false;
      }
    }
  },

  async mounted() {


    await this.getSegmentsAction()
      .then((response) => {
      })
      .catch((response) => {
        console.log(response);
      });


  },


};
</script>